import { getData, getTimestampData, updateFile } from '@/components/report/service';
import DeliveryRoute from '@/Entity/DeliveryRoute';
import Queryable from '@/Entity/Tools/Queryable';
import GenerateCondit, { Bound } from '@/models/GenerateCondit';
import { GetOrganizationAuth, getProvinceAreaData } from '@/services/area';
import { message } from 'antd';

import {
  getProduct,
  getToDay,
  SKETCHTICKET,
  SKETCHTICKET_SIZE,
  TICKET,
  CALCWEIGHT,
  PIECE,
  Aggregator,
} from '@/models/GenerateCondit/Interrelated';
import moment from 'moment';

const dateRange = getToDay();

const params = {
  queryDate: moment(dateRange[0]).add(-1, 'days'), // moment(new Date()).format('YYYY-MM-DD 12:00:00'),
  queryType: 0,
};

export default {
  namespace: 'notpressrouteboard',
  state: {
    // 汇总-占比
    dataList: [],
    dateRange,

    // 查询条件
    searchFrom: { ...params },
    // 折线图
    productList: [],
    // 柱状图 数据
    productPieList: [],
    productWeightList: [],

    // 营运区 数据
    provinceList: [],
    xAxisList: [],
    y1AxisList: [],
    y2AxisList: [],
    ticketCount: 0,
    allTicketCount: 0,

    xAxisListWeight: [], // 结算重量数据
    y1AxisListWeight: [],
    y2AxisListWeight: [],
    weightCount: 0,
    allWeightCount: 0,

    productMarkTicketList: [],
    productMarkWeightList: [],

    showTable: false,
    showProvinceTab: false,
  },

  effects: {
    *getData(_, { call, put, select }) {
      //#region 图
      yield put({ type: 'getCountry' });
      yield put({ type: 'getProduct' }); // 获取产品类型占比
      yield put({ type: 'getProductMark' }); // 获取环节数据

      //#endregion
      const {
        searchFrom: { queryDate, queryType },
      } = yield select(({ notpressrouteboard }) => notpressrouteboard);

      const productType = getProduct(queryType);
      // const [dayDataList, totalDataList] = yield Promise.all([
      //   fetchData(queryDate, productType),
      //   fetchTotal(queryDate, productType),
      // ]);
      // ['loadProvinceArea'], //loadCenter
      const access = yield GetOrganizationAuth();
      yield getProvinceAreaData();
      yield put({
        type: 'updateState',
        payload: { showTable: !access.isCenter, showProvinceTab: access.isHead || access.isArea },
      });
      if (access.isCenter) {
        return;
      }

      const [
        dayDataList,
        totalDataList,
        centerDayDataList,
        centerTotalDataList,
        provincePieceList,
        centerPieceList,
      ] = yield Promise.all([
        fetchOneDayData(queryDate, ['loadProvinceArea'], productType, access),
        fetchOneDayTotal(queryDate, ['scanProvinceArea'], productType, access),
        // scanProvinceArea
        // 分拨数据
        fetchOneDayData(queryDate, ['loadCenter'], productType, access),
        fetchOneDayTotal(queryDate, ['scanSite'], productType, access),
        fetchOneDayPieceData(queryDate, ['loadProvinceArea'], productType, access),
        fetchOneDayPieceData(queryDate, ['loadCenter'], productType, access),
      ]);
      const [
        dayData,
        totalData,
        centerDayData,
        centerTotalData,
        provincePieceData,
        centerPieceData,
      ] = [
          getDayData(dayDataList, 'loadProvinceArea'),
          getTotal(totalDataList, 'scanProvinceArea'),

          getDayData(centerDayDataList, 'loadCenter'),
          getTotal(centerTotalDataList, 'scanSite'),

          getPieceData(provincePieceList, 'loadProvinceArea'),
          getPieceData(centerPieceList, 'loadCenter'),
        ];

      let dataList = dayData.map(day => {
        const findTotal = totalData.find(total => day.loadProvinceArea === total.scanProvinceArea);
        const findPiece = provincePieceData.find(
          total => day.loadProvinceArea === total.loadProvinceArea,
        );
        return { ...findTotal, ...findPiece, ...day };
      });

      const centerDataList = centerDayData.map(day => {
        const findTotal = centerTotalData.find(total => day.loadCenter === total.scanSite);
        const findPiece = centerPieceData.find(total => day.loadCenter === total.loadCenter);
        console.log('findPiece', findPiece);
        return { ...findTotal, ...findPiece, ...day };
      });
      yield put({ type: 'updateState', payload: { dataList, centerDataList } });

      function getDayData(dayDataList, fieldKey) {
        const data = new Queryable(dayDataList).GroupByField(fieldKey);
        const dataList = [];
        Object.keys(data).forEach(key => {
          const temp = { [fieldKey]: key, monthTicket: 0, monthCalcWeight: 0 };
          data[key].forEach(item => {
            // const i = parseInt(moment(item.time).format('DD'));
            // temp[`sketchTicket${i}`] = item.SketchTicket;
            // temp.monthTicket += item.SketchTicket;

            const piece = Math.abs(item.piece);
            temp[`sketchTicket`] = item.SketchTicket;
            temp['calcWeight'] = item.calcWeight;

            // temp.monthTicket += item.SketchTicket;
            // temp.monthCalcWeight += item.calcWeight;
          });
          dataList.push(temp);
        });
        return dataList;
      }

      function getTotal(dayDataList, fieldKey) {
        const data = new Queryable(dayDataList).GroupByField(fieldKey);
        const dataList = [];
        Object.keys(data).forEach(key => {
          const temp = { [fieldKey]: key, monthTotalTicket: 0, monthTotalCalcWeight: 0 };
          data[key].forEach(item => {
            // const i = parseInt(moment(item.time).format('DD'));
            // const ticket = Math.abs(item.ticket);
            // temp[`ticket${i}`] = ticket;
            const ticket = Math.abs(item.ticket);
            const calcWeight = Math.abs(item.calcWeight);
            temp[`ticket`] = ticket;
            temp[`allCalcWeight`] = calcWeight;
          });
          dataList.push(temp);
        });
        return dataList;
      }

      function getPieceData(dayDataList, fieldKey) {
        const data = new Queryable(dayDataList).GroupByField(fieldKey);
        const dataList = [];
        Object.keys(data).forEach(key => {
          const temp = { [fieldKey]: key, monthTicket: 0, monthCalcWeight: 0 };
          data[key].forEach(item => {
            const piece = Math.abs(item.piece);
            temp['piece'] = item.piece;
          });
          dataList.push(temp);
        });
        return dataList;
      }
    },
    //全国--折线图
    *getCountry(_, { call, put, select }) {
      const access = yield GetOrganizationAuth();
      const {
        searchFrom: { queryDate, queryType },
      } = yield select(({ notpressrouteboard }) => notpressrouteboard);
      const productType = getProduct(queryType);

      const [dayDataList, totalDataList] = yield Promise.all([
        fetchDataLine(queryDate, productType, access),
        fetchTotalLine(queryDate, productType, access),
      ]);
      const xAxisList = [];
      const y1AxisList = [];
      const y2AxisList = [];
      let ticketCount = 0;
      let allTicketCount = 0;

      const xAxisListWeight = [];
      const y1AxisListWeight = [];
      const y2AxisListWeight = [];
      let weightCount = 0;
      let allWeightCount = 0;

      for (let index = 0; index < totalDataList.length; index++) {
        const totalItem = totalDataList[index];
        let dayItem = dayDataList.find(
          m => m.timestamp.slice(0, 10) === totalItem.timestamp.slice(0, 10),
        ) ?? { SketchTicket: 0, calcWeight: 0 };

        const totalTicket = Math.abs(totalItem.ticket || 0);
        const totalWeight = Math.abs(totalItem.calcWeight || 0);

        if (totalTicket >= dayItem.SketchTicket) {
          xAxisList.push(moment(totalItem.timestamp).format('YYYY-MM-DD HH:mm:ss'));
          y1AxisList.push(dayItem.SketchTicket);
          y2AxisList.push(parseFloat(((dayItem.SketchTicket / totalTicket) * 100).toFixed(2)));
          ticketCount += dayItem.SketchTicket;
          allTicketCount += totalTicket;
        }
        if (totalWeight >= dayItem.calcWeight) {
          xAxisListWeight.push(moment(totalItem.timestamp).format('YYYY-MM-DD HH:mm:ss'));
          y1AxisListWeight.push(dayItem.calcWeight);
          y2AxisListWeight.push(parseFloat(((dayItem.calcWeight / totalWeight) * 100).toFixed(2)));
          weightCount += dayItem.calcWeight;
          allWeightCount += totalWeight;
        }
      }
      yield put({
        type: 'updateState',
        payload: {
          xAxisList,
          y1AxisList,
          y2AxisList,
          xAxisListWeight,
          y1AxisListWeight,
          y2AxisListWeight,
          ticketCount,
          allTicketCount,
          weightCount,
          allWeightCount,
        },
      });
      return;
    },
    //产品--饼状图
    *getProduct(_, { call, put, select }) {
      const access = yield GetOrganizationAuth();
      const {
        searchFrom: { queryDate, queryType },
      } = yield select(({ notpressrouteboard }) => notpressrouteboard);
      const productType = getProduct(queryType);
      const result = yield fetchDataPie(queryDate, productType, access);
      console.log('result', result);

      const allTicket = result.reduce((pre, curr) => pre + curr.SketchTicket, 0);
      const allWeight = result.reduce((pre, curr) => pre + curr.calcWeight, 0);

      const productPieList = result
        .sort((item1, item2) => item2.SketchTicket - item1.SketchTicket)
        .map(item => {
          // const allTicket = result.reduce(pre, curr => pre + curr);
          return {
            name: item.productType,
            value: `${((item.SketchTicket / allTicket) * 100).toFixed(2)}`,
          };
        });

      const productWeightList = result
        .sort((item1, item2) => item2.calcWeight - item1.calcWeight)
        .map(item => {
          return {
            name: item.productType,
            value: `${((item.calcWeight / allWeight) * 100).toFixed(2)}`,
          };
        });

      yield put({
        type: 'updateState',
        payload: {
          productPieList,
          productWeightList,
        },
      });
    },

    //产品--环节柱状图数据
    *getProductMark(_, { call, put, select }) {
      const access = yield GetOrganizationAuth();
      const {
        searchFrom: { queryDate, queryType },
      } = yield select(({ notpressrouteboard }) => notpressrouteboard);
      const productType = getProduct(queryType);
      const result = yield fetchDataMark(queryDate, productType, access);
      console.log('result', result);

      const allTicket = result.reduce((pre, curr) => pre + curr.SketchTicket, 0);
      const allWeight = result.reduce((pre, curr) => pre + curr.calcWeight, 0);

      const productMarkTicketList = result
        .sort((item1, item2) => item2.SketchTicket - item1.SketchTicket)
        .map(item => {
          // const allTicket = result.reduce(pre, curr => pre + curr);
          return {
            name: item.locationMark,
            value: `${((item.SketchTicket / allTicket) * 100).toFixed(2)}`,
          };
        });

      const productMarkWeightList = result
        .sort((item1, item2) => item2.calcWeight - item1.calcWeight)
        .map(item => {
          return {
            name: item.locationMark,
            value: `${((item.calcWeight / allWeight) * 100).toFixed(2)}`,
          };
        });

      yield put({
        type: 'updateState',
        payload: {
          productMarkTicketList,
          productMarkWeightList,
        },
      });
    },
    *updateFile({ payload }, { call, put, select }) {
      // let { searchParams, auth } = yield select(({ notpressrouteboard }) => notpressrouteboard);
      // console.log("导出", payload);
      const formData = new FormData();
      formData.append('file', payload.sheet2blob, payload.fileName + ".xlsx");
      formData.append('pageName', payload.pageName);
      // delete params.organizationName;
      const result = yield call(updateFile, formData);
      if (result && result.code === 1) {
        message.success('导出成功');
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};

// 获取本月至今每天数据
function fetchData(dateRange, ...productType) {
  const condit = new GenerateCondit({
    dataSource: 'delivery_dis_accord_result',
    dimensions: ['loadProvinceArea'],
    aggregators: [SKETCHTICKET, CALCWEIGHT],
    startDate: moment(moment(dateRange).format('YYYY-MM-01 12:00:00')).format(
      'YYYY-MM-DD 12:00:00',
    ),
    endDate: moment(dateRange)
      .add(1, 'days')
      .format('YYYY-MM-DD HH:mm:ss'),
    simpleGranularity: null,
    durationGranularity: {
      duration: '86400000',
      origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
    },
  }).converCondit({ ...productType });
  const result = getData(condit);
  return result;
}
// 获取一天数据
function fetchOneDayData(dateRange, dimensions, productType, access) {
  const condit = new GenerateCondit({
    dataSource: 'delivery_dis_accord_result',
    dimensions: dimensions, //
    aggregators: [SKETCHTICKET, CALCWEIGHT],
    // startDate: moment(dateRange).format('YYYY-MM-DD 00:00:00'),
    // endDate: moment(dateRange)
    //   // .add(1, 'days')
    //   .format('YYYY-MM-DD 23:59:59'),
    startDate: moment(dateRange).format('YYYY-MM-DD 12:00:00'),
    endDate: moment(dateRange)
      .add(1, 'days')
      .format('YYYY-MM-DD 12:00:00'),
    simpleGranularity: 'all',
    // durationGranularity: {
    //   duration: '86400000',
    //   origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
    // },
  }).converCondit({
    ...productType,
    [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
  });
  const result = getData(condit);
  return result;
}

// 获取一天数据
function fetchOneDayPieceData(dateRange, dimensions, productType, access) {
  const condit = new GenerateCondit({
    dataSource: 'delivery_dis_accord_result',
    dimensions: dimensions, //
    aggregators: [new Aggregator('thetaSketch', 'piece', 'subBillNo', 32768)],
    // startDate: moment(dateRange).format('YYYY-MM-DD 00:00:00'),
    // endDate: moment(dateRange)
    //   // .add(1, 'days')
    //   .format('YYYY-MM-DD 23:59:59'),
    startDate: moment(dateRange).format('YYYY-MM-DD 12:00:00'),
    endDate: moment(dateRange)
      .add(1, 'days')
      .format('YYYY-MM-DD 12:00:00'),
    simpleGranularity: 'all',
    // durationGranularity: {
    //   duration: '86400000',
    //   origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
    // },
  }).converCondit({
    ...productType,
    [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
  });
  const result = getData(condit);
  return result;
}

function fetchTotal(dateRange, ...productType) {
  // const bound = new Bound('piece', 0)
  const condit = new GenerateCondit({
    dataSource: 'actual_load_unload_waybill_day_result',
    dimensions: ['scanProvinceArea'],
    aggregators: [TICKET, CALCWEIGHT],
    startDate: moment(moment(dateRange).format('YYYY-MM-01 00:00:00')).format(
      'YYYY-MM-DD 00:00:00',
    ),
    endDate: moment(dateRange)
      .add(1, 'days')
      .format('YYYY-MM-DD 00:00:00'),
    simpleGranularity: 'day',
  })
    // .pushBoundFilters(bound)
    .converCondit({ scanType: '分拨装车', ...productType });
  const result = getData(condit);
  return result;
}

// 获取一天总计数据
function fetchOneDayTotal(dateRange, dimensions, productType, access) {
  // const bound = new Bound('piece', 0)
  const condit = new GenerateCondit({
    dataSource: 'actual_load_unload_waybill_day_result',
    dimensions: dimensions,
    aggregators: [TICKET, CALCWEIGHT],
    startDate: moment(dateRange).format('YYYY-MM-DD 00:00:00'),
    endDate: moment(dateRange)
      // .add(1, 'days')
      .format('YYYY-MM-DD 23:59:59'),
    simpleGranularity: 'day',
  })
    // .pushBoundFilters(bound)
    .converCondit({
      scanType: '分拨装车',
      ...productType,
      [access.isArea ? 'scanProvinceArea' : 'scanSite']: access?.name,
    });
  const result = getData(condit);
  return result;
}

function fetchDataLine(dateRange, productType, access) {
  const condit = new GenerateCondit({
    dataSource: 'delivery_dis_accord_result',
    dimensions: null,
    aggregators: [SKETCHTICKET_SIZE(17), CALCWEIGHT],
    startDate: moment(moment(dateRange).format('YYYY-MM-01 12:00:00')).format(
      'YYYY-MM-DD 12:00:00',
    ),
    endDate: moment(dateRange)
      .add(1, 'days')
      .format('YYYY-MM-DD HH:mm:ss'),
    simpleGranularity: null,
    durationGranularity: {
      duration: '86400000',
      origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
    },
  }).converCondit({
    ...productType,
    [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
  });
  const result = getTimestampData(condit);
  return result;
}

function fetchTotalLine(dateRange, productType, access) {
  // const bound = new Bound('piece', 0)
  const condit = new GenerateCondit({
    dataSource: 'actual_load_unload_waybill_day_result',
    dimensions: [],
    aggregators: [TICKET, CALCWEIGHT],
    startDate: moment(moment(dateRange).format('YYYY-MM-01 00:00:00')).format(
      'YYYY-MM-DD 00:00:00',
    ),
    endDate: moment(dateRange)
      .add(1, 'days')
      .format('YYYY-MM-DD 00:00:00'),
    simpleGranularity: 'day',
  })
    // .pushBoundFilters(bound)
    .converCondit({
      scanType: '分拨装车',
      ...productType,
      [access.isArea ? 'scanProvinceArea' : 'scanSite']: access?.name,
    });
  const result = getTimestampData(condit);
  return result;
}

function fetchDataPie(dateRange, productType, access) {
  const condit = new GenerateCondit({
    dataSource: 'delivery_dis_accord_result',
    dimensions: ['productType'],
    aggregators: [SKETCHTICKET_SIZE(19), CALCWEIGHT],
    startDate: moment(moment(dateRange).format('YYYY-MM-01 12:00:00')).format(
      'YYYY-MM-DD 12:00:00',
    ),
    endDate: moment(dateRange)
      .add(1, 'days')
      .format('YYYY-MM-DD HH:mm:ss'),
    simpleGranularity: 'all',
    durationGranularity: {
      duration: '86400000',
      origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
    },
  }).converCondit({
    ...productType,
    [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
  });
  const result = getData(condit);
  return result;
}

function fetchDataMark(dateRange, productType, access) {
  const condit = new GenerateCondit({
    dataSource: 'delivery_dis_accord_result',
    dimensions: ['locationMark'],
    aggregators: [SKETCHTICKET_SIZE(19), CALCWEIGHT],
    startDate: moment(moment(dateRange).format('YYYY-MM-01 12:00:00')).format(
      'YYYY-MM-DD 12:00:00',
    ),
    endDate: moment(dateRange)
      .add(1, 'days')
      .format('YYYY-MM-DD HH:mm:ss'),
    simpleGranularity: 'all',
    durationGranularity: {
      duration: '86400000',
      origin: moment(dateRange).format('YYYY-MM-01 12:00:00'),
    },
  }).converCondit({
    ...productType,
    [access.isArea ? 'loadProvinceArea' : 'loadCenter']: access?.name,
  });
  const result = getData(condit);
  return result;
}
